export const calculateRoundedPercentage = (
  numerator: number,
  denominator: number
): number => {
  const percentage = (numerator / denominator) * 100;
  return Math.round(percentage * 100) / 100;
};

export const roundToTwoDecimals = (value: number): number => {
  return Number(value.toFixed(2));
};

export const roundToThreeDecimals = (num: number): number => {
  return Number(num.toFixed(3));
};
